import React, { useState } from 'react';
import { Shield, Zap, BarChart, CreditCard, ExternalLink, Check, Grid } from 'lucide-react';
const apps = [{
  id: 'sentinel',
  name: 'AVA Sentinel',
  desc: 'Real-time server monitoring and DDoS protection.',
  icon: Shield,
  color: 'text-indigo-600',
  bg: 'bg-indigo-50'
}, {
  id: 'finance',
  name: 'AVA Finance',
  desc: 'Automated tax calculation and multi-currency invoicing.',
  icon: CreditCard,
  color: 'text-emerald-600',
  bg: 'bg-emerald-50'
}, {
  id: 'crm',
  name: 'AVA CRM',
  desc: 'White-labeled customer management and support portal.',
  icon: BarChart,
  color: 'text-purple-600',
  bg: 'bg-purple-50'
}];
export function AppCenter() {
  const [enabledApps, setEnabledApps] = useState<string[]>(['sentinel']);
  const toggleApp = (id: string) => {
    setEnabledApps(prev => prev.includes(id) ? prev.filter(a => a !== id) : [...prev, id]);
  };
  return <div className="space-y-8 max-w-[1600px] mx-auto" data-id="element-883">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-884">
        <div data-id="element-885">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-886">
            AVA Tool Marketplace
          </h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-887">
            Enable specialized tools for your white-label clients.
          </p>
        </div>
        <div className="p-2 bg-indigo-50 text-indigo-600 rounded-lg" data-id="element-888">
          <Grid size={24} data-id="element-889" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-890">
        {apps.map(app => {
        const isEnabled = enabledApps.includes(app.id);
        const Icon = app.icon;
        return <div key={app.id} className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm flex flex-col justify-between group" data-id="element-891">
              <div className="space-y-4" data-id="element-892">
                <div className="flex items-start justify-between" data-id="element-893">
                  <div className={`p-3 rounded-lg ${app.bg} ${app.color}`} data-id="element-894">
                    <Icon size={24} data-id="element-895" />
                  </div>
                  <div onClick={() => toggleApp(app.id)} className={`w-12 h-6 rounded-full relative cursor-pointer transition-all duration-200 ${isEnabled ? 'bg-indigo-600' : 'bg-gray-200'}`} data-id="element-896">
                    <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all duration-200 ${isEnabled ? 'left-7' : 'left-1'}`} data-id="element-897"></div>
                  </div>
                </div>
                <div data-id="element-898">
                  <h4 className="font-bold text-slate-900" data-id="element-899">{app.name}</h4>
                  <p className="text-xs text-gray-500 font-medium leading-relaxed mt-1" data-id="element-900">
                    {app.desc}
                  </p>
                </div>
              </div>
              <div className="mt-6 pt-4 border-t border-gray-100 flex items-center justify-between" data-id="element-901">
                <span className={`text-[10px] font-bold uppercase tracking-widest ${isEnabled ? 'text-indigo-600' : 'text-gray-400'}`} data-id="element-902">
                  {isEnabled ? 'Enabled for Clients' : 'Disabled'}
                </span>
                <button className="text-gray-400 hover:text-indigo-600 transition-colors" data-id="element-903">
                  <ExternalLink size={16} data-id="element-904" />
                </button>
              </div>
            </div>;
      })}
      </div>
    </div>;
}